const format = (source: string, ...params: (string | number)[]) => {
    if (!params.length) {
        return source;
    }
    let result = source;
    params.forEach((param, index) => {
        result = result.replace(new RegExp("\\{" + index + "\\}", "g"), () => param.toString());
    })
    return result;
};

export default format;
